import { NgModule, CUSTOM_ELEMENTS_SCHEMA, provideZonelessChangeDetection, provideAppInitializer, inject } from '@angular/core';

import { RouterModule } from '@angular/router';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MatButtonModule } from '@angular/material/button';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatIconModule } from '@angular/material/icon';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatBadgeModule } from '@angular/material/badge';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDialogModule } from '@angular/material/dialog';
import { MatMenuModule } from '@angular/material/menu';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSliderModule } from '@angular/material/slider';
import { MatSnackBar, MatSnackBarModule } from '@angular/material/snack-bar';
import { Toastbar } from 'src/util/toastbar';
import { MatBottomSheetModule } from '@angular/material/bottom-sheet';

import { AppComponent } from './app.component';
import { FooterComponent } from './footer/footer.component';
import { DicemacroComponent } from './dicemacro/dicemacro.component';
import { CanvasComponent } from './canvas/canvas.component';
import { ChatComponent } from './chat/chat.component';
import { DiceComponent } from './chat/dice.component';
import { DiceGroupComponent } from './chat/dicegroup.component';
import { TokenizerComponent } from './tokenizer/tokenizer.component';
import { ControlComponent } from './control/control.component';
import { ControlFogComponent } from './control/control-fog/control-fog.component';
import { ControlTokensComponent } from './control/control-tokens/control-tokens.component';
import { ControlUploadsComponent } from './control/control-uploads/control-uploads.component';
import { ControlGraffitiComponent } from './control/control-graffiti/control-graffiti.component';
import { ControlMappingComponent } from './control/control-mapping/control-mapping.component';
import { CommandBarComponent } from './command-bar/command-bar.component';
import { RoomComponent } from './room/room.component';
import { CampaignComponent } from './campaign/campaign.component';
import { TokenComponent } from './token/token.component';
import { ColorpickerComponent } from './colorpicker/colorpicker.component';
import { ClickOutsideDirective } from 'src/util/click-outside';
import { MiddleclickDirective } from 'src/util/middleclick';
import { SettingsComponent } from './settings/settings.component';
import { AssetsComponent } from './assets/assets.component';
import { ConfirmationDialog } from './confirmation-dialog.component';
import { MatTooltipModule } from '@angular/material/tooltip';
import { UsersDialogComponent } from './users/users-dialog.component';

import { ForceViewSyncMessage, StatelessMessage, StatelessMessengerService } from './messenger-service';


@NgModule({
    declarations: [
        AppComponent,
        CanvasComponent,
        ChatComponent,
        DiceComponent,
        DiceGroupComponent,
        TokenizerComponent,
        ControlComponent,
        ControlFogComponent,
        FooterComponent,
        DicemacroComponent,
        ControlTokensComponent,
        ControlUploadsComponent,
        ControlGraffitiComponent,
        ControlMappingComponent,
        CommandBarComponent,
        ConfirmationDialog,
        RoomComponent,
        CampaignComponent,
        TokenComponent,
        ColorpickerComponent,
        SettingsComponent,
        AssetsComponent,
        UsersDialogComponent,
    ],
    imports: [
        RouterModule.forRoot([
            { path: 'campaign', component: CampaignComponent },
            { path: ':hostuser/:room', component: RoomComponent },
            { path: ':hostuser/:room/:password', component: RoomComponent },
        ]),
        BrowserModule,
        FormsModule,
        BrowserAnimationsModule,
        MatButtonModule,
        MatToolbarModule,
        MatIconModule,
        MatSidenavModule,
        MatBadgeModule,
        MatCheckboxModule,
        MatDialogModule,
        MatMenuModule,
        MatSliderModule,
        MatSlideToggleModule,
        MatSnackBarModule,
        MatBottomSheetModule,
        ClickOutsideDirective,
        MiddleclickDirective,
        MatTooltipModule
    ],
    providers: [
        provideZonelessChangeDetection(),
        { provide: MatSnackBar, useClass: Toastbar },
        provideAppInitializer(() => {
            const snackbar = inject(MatSnackBar)
            const statelessMessengerService = new StatelessMessengerService(snackbar);
            (window as any).onStateless = statelessMessengerService.onStateless.bind(statelessMessengerService);
        }),
    ],
    bootstrap: [AppComponent],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class AppModule { }
